export const getUserLang = () => {
  let lang = localStorage.getItem('lang');
  if (!lang) {
    lang = navigator.language.slice(0, 2);
    localStorage.setItem('lang', lang);
  }
  return lang;
};
